var _effectorFileName = "/src/page-content/case-page/ui.tsx";
import { useMemo } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { STUDENTS_CASES, type CaseInfo, type StudentCase } from '@/widgets/layouts/main/students-cases/constants/cases-list';
import { Article } from '@/shared/components/article';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { PageSeo } from '@/shared/lib/seo';
import { Case } from './components/case-info';
import { Main } from './components/main';
export const SpecificCasePage = () => {
  const router = useRouter();
  const {
    t: tCases
  } = useTranslation('cases-list');
  const {
    t: tPage
  } = useTranslation('cases-page');
  const pagePath = router.asPath.split('?')[0];
  const caseIndex = STUDENTS_CASES.findIndex((c: StudentCase) => c.href === pagePath);
  const studentCase = caseIndex >= 0 ? STUDENTS_CASES[caseIndex] : undefined;
  const translatedName = caseIndex >= 0 ? tCases(`cases.${caseIndex}.name`) : '';
  const translatedDescription = caseIndex >= 0 ? tCases(`cases.${caseIndex}.description`) : '';
  const studentCaseInfo = useMemo((): CaseInfo | undefined => {
    if (!studentCase?.info?.review || caseIndex < 0) return undefined;
    const sections = tCases(`cases.${caseIndex}.infoSections`, {
      returnObjects: true
    });
    if (!Array.isArray(sections)) return undefined;
    return {
      sections: sections as CaseInfo['sections'],
      review: studentCase.info.review
    };
  }, [caseIndex, studentCase, tCases]);
  return <>
      <PageSeo title={studentCase ? tPage('seo.caseTitle', {
      name: translatedName
    }) : tPage('notFound.title')} description={studentCase ? tPage('seo.caseDescription', {
      name: translatedName
    }) : tPage('seo.description')} />

      {studentCase && <>
          <Main description={translatedDescription} name={translatedName} />

          <div className="overflow-hidden">
            <Case studentCaseInfo={studentCaseInfo} studentName={translatedName} />

            <CallToAction header={tPage('ctaWantSame')} withForm />
          </div>
        </>}

      {!studentCase && <Article tag="main">
          <div className="flex flex-col place-items-center">
            <TextGradient className="mb-2 text-center text-3xl xs:text-5xl sm:mb-6 md:text-6xl" tag="h1" text={tPage('notFound.title')} />

            <Link href="/cases" aria-label={tPage('notFound.readCasesAria')}>
              <Button aria-label={tPage('notFound.readCasesAria')}>{tPage('notFound.readCases')}</Button>
            </Link>
          </div>
        </Article>}
    </>;
};
SpecificCasePage.Layout = MainLayout;